import type { StyleRule } from '@archipro-design/aria';
import {
    checkboxClassName,
    indicatorRadioClassName,
    labelClassName,
    pxArrayToRem,
    pxToRem,
} from '@archipro-design/aria';

export const OptionRadioGroup: StyleRule<{ visible: boolean }> = ({
    visible,
    theme,
}) => ({
    display: visible ? 'block' : 'none',
    padding: pxArrayToRem([8, 0]),
    [`& .${checkboxClassName}`]: {
        lineHeight: '100%',
        fontSize: theme.siteVariables.fontSizes['caption03'],
        marginBottom: theme.siteVariables.spaces['space-16'],
        alignItems: 'flex-start',
        margin: pxArrayToRem([1, 0, 8, 1]),
        [`&[aria-checked="true"] .${labelClassName}`]: {
            ...theme.siteVariables.textStyles.Text.Medium65,
        },
        [`&[aria-checked="true"] .${indicatorRadioClassName}`]: {
            marginTop: pxToRem(-1),
        },
        [`&[aria-checked="false"] .${indicatorRadioClassName}`]: {
            borderWidth: '1px',
            width: pxToRem(15),
            height: pxToRem(15),
            marginRight: pxToRem(1),
            marginTop: pxToRem(-2),
        },
        ['& .' + labelClassName]: {
            fontSize: 'inherit',
            lineHeight: '100%',
            marginTop: pxToRem(4),
            marginLeft: pxToRem(5),
        },
    },
});
